// extracted by mini-css-extract-plugin
export default {"root":"PhoneField_root__LAVCM","wrapper":"PhoneField_wrapper__mGbGw","rootError":"PhoneField_rootError__Vlypk","error":"PhoneField_error__8HBii"};